import EntityType from '@enums/EntityType';

export const PropertyEntity = Object.freeze({
  [EntityType.ACTIVITY]: EntityType.ACTIVITY_PROPERTY,
  [EntityType.ROLE]: EntityType.ROLE_PROPERTY,
  [EntityType.GROUP]: EntityType.GROUP_PROPERTY,
});

export const PropertyValueEntity = Object.freeze({
  [EntityType.ACTIVITY]: EntityType.ACTIVITY_PROPERTY_VALUE,
  [EntityType.ROLE]: EntityType.ROLE_PROPERTY_VALUE,
  [EntityType.GROUP]: EntityType.GROUP_PROPERTY_VALUE,
});

export const SkillEntity = Object.freeze({
  [EntityType.ROLE]: EntityType.ROLE_SKILL,
  [EntityType.PERSON]: EntityType.PERSON_SKILL,
});

export const SkillLevelEntity = Object.freeze({
  [EntityType.ROLE]: EntityType.ROLE_SKILL_LEVEL,
  [EntityType.PERSON]: EntityType.PERSON_SKILL_LEVEL,
});

export const TagEntity = Object.freeze({
  [EntityType.ACTIVITY]: EntityType.ACTIVITY_TAG,
  [EntityType.ROLE]: EntityType.ROLE_TAG,
  [EntityType.GROUP]: EntityType.GROUP_TAG,
});

export const TagCategoryEntity = Object.freeze({
  [EntityType.ACTIVITY]: EntityType.ACTIVITY_TAG_CATEGORY,
  [EntityType.ROLE]: EntityType.ROLE_TAG_CATEGORY,
  [EntityType.GROUP]: EntityType.GROUP_TAG_CATEGORY,
});
